export const SMS_MESSAGE_TABLE = "smsMessages"
export const SMS_MESSAGE_TABLE_SCHEMA =
  "id, companyId, chatId, status, direction, timestamp, syncId, [chatId+timestamp]"
